<template>
  <div>
    <v-card>
      <div class="pa-3 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9"> </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="datatableItems"
        :search="search"
        :items-per-page="10"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
        class="elevation-1"
      >
        <template v-slot:item.id_reference="{ item }">
          <v-btn @click="$copy(item.id_reference)" x-small>{{
            item.id_reference
          }}</v-btn>
        </template>

        <template
          v-for="(value, index) in valueColors"
          v-slot:[`item.${value}`]="{ item }"
        >
          <span
            class="caption"
            :key="index"
            :class="getColor(item[value], item.id_operation)"
          >
            {{ item[value] }}
          </span>
        </template>

        <template v-slot:item.status_operation="{ item }">
          <div v-html="item.status_operation"></div>
        </template>
        <template v-slot:item.current_balance="{ item }">
          <div v-if="item.current_balance != null">
            {{ item.current_balance }}
          </div>
          <v-icon v-else> mdi-dots-horizontal </v-icon>
        </template>
        <template v-slot:item.previous_balance="{ item }">
          <div v-if="item.previous_balance != null">
            {{ item.previous_balance }}
          </div>
          <v-icon v-else> mdi-dots-horizontal </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "adm-online-users-players-releasesOnline",
  data: () => ({
    search: "",
    datatableItems: [],
    valueColors: ["value_consolidated"],
  }),
  computed: {
    headers() {
      const headers = [
        {
          text: this.$t("idOperation"),
          value: "id_reference",
          align: "center",
          sortable: true,
        },
        {
          text: this.$t("dateHour"),
          value: "date",
          align: "center",
          sortable: true,
        },
        {
          text: this.$t("operation"),
          value: "name_operation",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("statusLabel"),
          value: "status_operation",
          align: "center",
          sortable: true,
        },
        {
          text: this.$t("value"),
          value: "value_consolidated",
          align: "center",
          sortable: true,
        },
        {
          text: this.$t("previousBalance"),
          value: "previous_balance",
          align: "center",
          sortable: true,
        },
        {
          text: this.$t("remainingBalance"),
          value: "current_balance",
          align: "center",
          sortable: true,
        },
      ];

      if (this.$store.state.operator.casino != "0") {
        headers.push({
          text: this.$t("gameName"),
          value: "name_game",
          align: "center",
          sortable: true,
        });
      }

      return headers;
    },
    idPlayer() {
      return this.$store.state.filters.autocompletePlayers.id;
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  mounted() {
    this.getRelease();
  },
  watch: {
    saveFilters(val) {
      if (this.$route.name === "AdministratorOnlinePlayerReleases") {
        val && this.getRelease();
      }
    },
  },
  methods: {
    getRelease() {
      const body = {
        id_player: this.idPlayer,
        ...this.rangeDate,
      };
      this.$request
        .post("/administrator/players/onlineEntries", body)
        .then((response) => {
          this.datatableItems = response.dados;
          if (!this.datatableItems) {
            return;
          }
          this.datatableItems.forEach((item) => {
            if (item.name_game == null) {
              item.name_game = "SportsBook";
            }

            // Tratamento na Data(date) de acordo com o status da operação.
            // solicitado
            if (item.status_operation == "1") {
              item.date = new Date(
                item.date_entry.replace(" ", "T")
              ).toLocaleString();
            }
            // autorizado
            if (item.status_operation == "2") {
              item.date = new Date(
                item.date_authorization.replace(" ", "T")
              ).toLocaleString();
            }
            // consolidado OU cancelado
            if (item.status_operation == "3" || item.status_operation == "4") {
              item.date = new Date(
                item.date_finalized.replace(" ", "T")
              ).toLocaleString();
            }
            item.status_operation = this.statusOperationUI(
              item.status_operation
            );

            // Tratamento para que
            // os lançamentos do jogador sejam vistos pelo ADM
            // da mesma forma que o Jogador vê (getColor), de acordo com o id_operation

            // Legenda id_operation
            //1 - Aposta Online, - value_consolidated (-)
            //2 - Extorno Aposta, - value_consolidated (+)
            //3 - Compra de Crédito Online, - value_consolidated (+)
            //4 - Pagamento de Aposta, - value_consolidated (+)
            //5 - Bônus de depósito, value_considated (+)
            //6 - Saque de Crédito Online - value_requested (-)
            //7 - Aposta Online com Bônus - value_requested (-)
            //8 - Saque de crédito instantâneo, value_requested (-)
            //9 - Compra de Crédo Online por Adminstrador, value_considated (+)
            //10 - Promoção de Bônus, value_considated (+)
            //11 - Encerrar Apostas, value_consolidated (+)
            //12 - Saldo de Migração, value_consolidated (+)
            //13 - Verificação Bancária (-)
            //14 - Cancelamento Prêmio SportsBook, value_consolidated (-)
            //15 - Ativação do Prêmio
            //101 - Aposta Cassino, value_consolidated (-)
            //102 - Prêmio Cassino, value_consolidated (+)
            //103 - Reembolso Cassino, value_consolidated (+)
            //104 - Prêmio Jackpot (+)
            //105 - Prêmio Campanha Cassino (+)
            //106 - Prêmio Drop&Wins (+)
            // 107 - Ajuste Cassino (Pode ser negativo ou positivo)
            // 114 - Aposta isenta cassino (-)
            // 109 - Rollback de prêmio de cassino (-)
            // 117 - Rollback de prêmio de jogador isento (-)
            // 108 - Rollback de aposta de cassino (+)
            // 116 - Rollback de aposta de jogador isento (+)

            if (
              item.id_operation == "1" ||
              item.id_operation == "6" ||
              item.id_operation == "7" ||
              item.id_operation == "8" ||
              item.id_operation == "13" ||
              item.id_operation == "14" ||
              item.id_operation == "101" ||
              item.id_operation == "109" ||
              item.id_operation == "114" ||
              item.id_operation == "117"
            ) {
              item.value_consolidated = item.value_consolidated * -1;
            }

            if (item.id_operation == "113") {
              item.name_operation = "Freespins";
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    statusOperationUI(value) {
      const obj = {
        1: `<span class="my-1 v-chip theme--light v-size--small orange darken-3 white--text"><span class="v-chip__content text">${this.$t(
          "requisted"
        )}</span></span>`,
        2: `<span class="my-1 v-chip theme--light v-size--small orange darken-3 white--text"><span class="v-chip__content text">${this.$t(
          "authorized"
        )}</span></span>`,
        3: `<span class="my-1 v-chip theme--light v-size--small green darken  white--text"><span class="v-chip__content">${this.$t(
          "consolidated"
        )}</span></span>`,
        4: `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content">${this.$t(
          "didCancelled"
        )}</span></span>`,
      };
      return obj[value];
    },
    getColor(value, id_operation) {
      if (id_operation == 107) {
        return "white--text";
      }

      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
